import React from "react";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";

export type PreviewSendCertificateProps = {
  visible: boolean;
  onHide: () => void;
  pdfBlobUrl: string | null;
  isLoadingPdf: boolean;
};

const PreviewSendCertificate: React.FC<PreviewSendCertificateProps> = ({ visible, onHide, pdfBlobUrl, isLoadingPdf }) => (
  <Dialog header="Certificate Preview" visible={visible} style={{ width: "60vw" }} onHide={onHide} modal>
    <div style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {isLoadingPdf ? (
        <ProgressSpinner style={{width: '30px', height: '30px'}} />
      ) : pdfBlobUrl ? (
        <iframe
          src={pdfBlobUrl}
          title="Certificate PDF Preview"
          width="100%"
          height="100%"
          style={{ border: "none", minHeight: "500px" }}
        />
      ) : (
        <div>No PDF available for preview.</div>
      )}
    </div>
  </Dialog>
);

export default PreviewSendCertificate;
